module.exports = __webpack_public_path__ + "static/img/award-top.e0ae519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/award/award-top.png
// module id = FW+Z
// module chunks = 0